export enum UserEndpoints {
  USERS = '/api/external/v1/users',
}
